import { render } from "./sbImgUrl.vue?vue&type=template&id=32b9978f&scoped=true"
import script from "./sbImgUrl.vue?vue&type=script&lang=js"
export * from "./sbImgUrl.vue?vue&type=script&lang=js"

import "./sbImgUrl.vue?vue&type=style&index=0&id=32b9978f&lang=less&scoped=true"

import exportComponent from "/home/lcs/jenkins/workspace/v2-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32b9978f"]])

export default __exports__